import styled from "styled-components";

export const Container = styled.section`
  margin-top: 30px;
  margin-left: ${({ theme }) => theme.old.sizes.sidesMargin.large};
  margin-right: ${({ theme }) => theme.old.sizes.sidesMargin.large};
  padding-top: 30px;

  ${({ theme }) => theme.old.breakpoints.isTab} {
    margin-left: ${({ theme }) => theme.old.sizes.sidesMargin.small};
    margin-right: ${({ theme }) => theme.old.sizes.sidesMargin.small};
  }
`

export const ResultsTitle = styled.h3`
  color: ${({ theme }) => theme.old.colors.white};
  font-size: ${({ theme }) => theme.old.fonts.size.normal};
  margin-bottom: 30px;
`

export const ResultsGrid = styled.div`
  display: grid;
  gap: 50px 15px;
  grid-template-columns: repeat(7, 1fr);
  
  ${({ theme }) => theme.old.breakpoints.isLaptop} {
    grid-template-columns: repeat(6, 1fr);
  }

  ${({ theme }) => theme.old.breakpoints.isTabLand} {
    grid-template-columns: repeat(5, 1fr);
  }

  ${({ theme }) => theme.old.breakpoints.isTab} {
    grid-template-columns: repeat(3, 1fr);
  }

  ${({ theme }) => theme.old.breakpoints.isMobile} {
    grid-template-columns: repeat(2, 1fr);
  }
`